import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.002 16.998a1 1 0 0 1 1 1V18a1 1 0 0 1-1.023 1h-.002a1 1 0 0 1-.754-1.627l.013-.016.04-.046.02-.02.014-.015.028-.024a1 1 0 0 1 .664-.254m0-5.998a1 1 0 0 1 1 1v.002a1 1 0 0 1-1.023 1h-.002a1 1 0 0 1-.754-1.627l.013-.016.04-.046.02-.02.014-.015.028-.024a1 1 0 0 1 .204-.142l.016-.007A1 1 0 0 1 4.002 11M4 4.998q.218.002.407.088.011.005.023.012.033.014.065.033l.015.009.065.042.023.017a1 1 0 0 1 .121.106A1 1 0 0 1 3.978 7h-.002A1 1 0 0 1 3 6v-.002a1 1 0 0 1 1-1M20 5.258a.75.75 0 0 1 0 1.5H7a.75.75 0 1 1 0-1.5zM20 11.258a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1 0-1.5zM20 17.258a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1 0-1.5z"
  }));
}
var IcList = createNolIcon(/*#__PURE__*/forwardRef(SvgIcList));

export { IcList as I };
